export default {"src":"/_next/static/media/raydium.7d88dbe4.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};